import { render, staticRenderFns } from "./main.vue?vue&type=template&id=4328f831"
import script from "./main.vue?vue&type=script&lang=js"
export * from "./main.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/Paldia/Paldia FE/FE-Paldia-Dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4328f831')) {
      api.createRecord('4328f831', component.options)
    } else {
      api.reload('4328f831', component.options)
    }
    module.hot.accept("./main.vue?vue&type=template&id=4328f831", function () {
      api.rerender('4328f831', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/lottery/create/main.vue"
export default component.exports